import React from "react";

import { Link } from "react-router";

const Card = ({ parentClass , image, title, price, customClass, superOffer, link, label, className, card, cardBody, minimum, amount, discount_type }) => {
  return (
    <>
    <div className={`${parentClass}--item  ${customClass} ${card} border-0`}>
      <div className={`${parentClass}--item-inner ${cardBody}`}>
        <figure className={`${parentClass}--item-image`}>
            <img src={image} alt={title} width="" height="" />
        </figure>
        <div className={`${parentClass}--item-content`}>
            <div className={`${parentClass}--item-title`}>
                <h3 className="h4">{title}</h3>
                <h4 className="h4">{price}</h4>
            </div>
            <div  className={`${parentClass}--item-deatils`}>
              <h5 className="h5">{minimum}</h5>
              <div>
                <p>{amount}<span>{discount_type}</span></p>
              </div>
            </div>
          <p className="mb-0">{superOffer}</p>
          <div className={`${parentClass}--item-links`}><Link  to={link} className={className} >{label}</Link></div>
        </div>
      </div>
    </div>
    
    </>
  );
};

export default Card;

